import { Dropdown } from 'flowbite-react';
import propTypes from 'prop-types';
import React from 'react'
import { textDropdownTheme } from '../../../theme/flowbite.custom.theme';
import { DownloadIcon, TikGreenIcon } from '../../../theme/icons';

export const TextDropdownComponent = React.memo(({ handleSelect, options, selected, label, renderTrigger }) => {
    return (<Dropdown theme={textDropdownTheme} label={selected} icon={DownloadIcon} renderTrigger={renderTrigger} inline>
        {label && <Dropdown.Item disabled className=' flex gap-2 items-center text-sm text-secondary-500' >
            <span className='opacity-0'><TikGreenIcon /></span>{label}
        </Dropdown.Item>}
        {!!options?.length && options?.map(option =>
            <Dropdown.Item onClick={() => handleSelect(option)} className='font-semibold flex gap-2 items-center text-sm text-secondary-500' key={`${option?.id} + ${option?.value}`}>
                {selected && <>{option?.value === selected ? <span><TikGreenIcon /></span> : <span className='opacity-0'><TikGreenIcon /></span>}</>}
                {option?.icon} {option?.value}
            </Dropdown.Item>)}
    </Dropdown>)
})

TextDropdownComponent.propTypes = {
    options: propTypes.array,
    selected: propTypes.string,
    label: propTypes.string,
    handleSelect: propTypes.func,
    renderTrigger: propTypes.any
}

TextDropdownComponent.defaultProps = {
    options: [
        { id: 0, value: "Option 1" },
        { id: 1, value: "Option 2" },
        { id: 2, value: "Option 3" }
    ],
    selected: "",
    label: "",
    handleSelect: () => { },
    renderTrigger: ""
}